import React from 'react';

const flightTime = props => {
  const flightTime = props.flight_time.split(':');
  const hours =
    parseInt(flightTime[0], 10) > 0 ? parseInt(flightTime[0], 10) : false;
  const minutes = parseInt(flightTime[1], 10);

  return (
    <React.Fragment>
      {hours && <span>{hours} hour(s)&nbsp;&nbsp;</span>}
      {minutes} minute(s)
    </React.Fragment>
  );
};
export default flightTime;



// WEBPACK FOOTER //
// ./src/components/FlightTime/FlightTime.jsx